import goTo from '@/libs/functions/goTo'
import { setLangLocale } from '@/libs/functions/lang'
import { Button, Space } from 'antd-mobile'
import { useEffect, useState } from 'react'
// import { getLocale, useIntl } from 'umi'

export default function Index() {
  const [aaa, setAaa] = useState(null)
  // const intl = useIntl()
  // console.log('getLang master demo: ', intl, getLocale())
  useEffect(() => {
    console.log(!!window.__POWERED_BY_QIANKUN__) // 判断是否是 Qiankun 子应用);
  }, [])

  const changeLang = (lang: string, reload = false) => {
    setLangLocale(lang, true)
  }

  return (
    <div style={{ fontSize: 40 }}>
      <div>首页</div>
      {aaa.map((i) => {
        return <>i</>
      })}
      {/* <p>多语言
        {
          intl.formatMessage(
            {
              id: "common:nickname",
            }
          )
        }
      </p>
      <Space>
        <Button color='primary' onClick={() => goTo('/order/demo')}>去order</Button>
        <Button color='primary' onClick={() => changeLang('zh-CN')}>切换中文</Button>
        <Button color='primary' onClick={() => changeLang('en-US')} >切换英文</Button>
        <Button color='primary' onClick={() => changeLang('en-US', true)} >切换英文(刷新页面)</Button>
      </Space> */}
    </div>
  )
}
